module.exports = __webpack_public_path__ + "media/images/mother-day/motherday-template-ro-253423374aef5c32d3bc23f6f221edf1.png";